import React from 'react';
import { Link } from 'react-scroll';
import '../../styles/sections/Hero.css';

function Hero() {
  return (
    <section className="hero" style={{ backgroundImage: 'url(/images/hero/hero-background.webp)' }}>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-left">
          <h1>Transform Your Photos into Timeless Ceramic Tiles</h1>
          <p className="hero-subtitle">
            Create beautiful, personalized ceramic tiles from your favorite photos
          </p>
        </div>

        <div className="hero-right">
          <div className="conversion-demo">
            <div className="conversion-steps">
              <div className="conversion-step">
                <img 
                  src="/images/hero/remi_raw.jpeg" 
                  alt="Original photo" 
                  className="conversion-image"
                />
                <div className="conversion-label">Original Photo</div>
              </div>
              
              <div className="conversion-arrow">→</div>
              
              <div className="conversion-step">
                <img 
                  src="/images/hero/pet.png" 
                  alt="Converted tile" 
                  className="conversion-image"
                />
                <div className="conversion-label">Ceramic Tile Preview</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero; 